import {
  CATEGORY_STORE,
  CATEGORY_TOGGLE,
  CATEGORY_ACTIVE,
  CATEGORY_OPEN,
  LOADING_CATEGORY,
  NEWS
} from "./actionTypes";
import { categoryState } from "./stateModel";

// ------------------------------------
// Actions
// ------------------------------------

const receiveCategories = categories => ({
  type: CATEGORY_STORE,
  categories
});

export const storeCategories = categories => (dispatch, getState) => {
  const ac = parseInt(localStorage.getItem("OZ_ACTIVE_CATEGORY"));
  const oc = parseInt(localStorage.getItem("OZ_OPEN_CATEGORY"));
  if (!isNaN(ac)) dispatch(setOpenCategoryUnsafe(ac));
  dispatch(receiveCategories(categories));
  if (!isNaN(ac) && !isNaN(oc)) dispatch(toggleCategory(ac, oc));
  if (ac !== oc && !isNaN(ac) && !isNaN(oc)) {
    dispatch(toggleCategoryUnsafe(oc));
    dispatch(setOpenCategoryUnsafe(oc));
  }
  dispatch(loadingCategories(false));
};

const setOpenCategoryUnsafe = categoryId => ({
  type: CATEGORY_OPEN,
  categoryId
});

const toggleCategoryUnsafe = categoryId => ({
  type: CATEGORY_TOGGLE,
  categoryId
});

const setActiveCategoryUnsafe = categoryId => ({
  type: CATEGORY_ACTIVE,
  categoryId
});

export const setNewsCategory = () => ({
  type: NEWS
});

export const loadingCategories = status => ({
  type: LOADING_CATEGORY,
  status
});

export const toggleCategory = (categoryId, parentCategoryId) => dispatch => {
  if (categoryId === parentCategoryId) {
    dispatch(toggleCategoryUnsafe(parentCategoryId));
  }
  dispatch(setActiveCategoryUnsafe(categoryId));
  localStorage.setItem("OZ_ACTIVE_CATEGORY", parseInt(categoryId));
  localStorage.setItem("OZ_OPEN_CATEGORY", parseInt(parentCategoryId));
};

export const getVisibleCategories = state =>
  !state.category.list ? [] : state.category.list;
export const getOpenedCategories = state =>
  !state.category.openedCategory ? [] : state.category.openedCategory;
export const getActivedCategory = state =>
  !state.category.active ? null : state.category.active;
export const getCategoryList = state => state || [];
export const getCategoryName = (state, lang) => {
  if (state.active) {
    return state && state.list
      ? state.list.find(c => c.id === state.active).route[lang].title
      : "All Products";
  }
};

export const actions = {
  storeCategories,
  toggleCategory
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function categoryReducer(state = categoryState, action) {
  // debugger;
  switch (action.type) {
    case CATEGORY_STORE:
      return {
        ...state,
        list: action.categories
      };
    case CATEGORY_TOGGLE:
      let ocNew = state.openedCategory ? state.openedCategory : [];
      if (
        state.openedCategory &&
        state.openedCategory.findIndex(oc => oc === action.categoryId) === -1
      ) {
        ocNew = [...state.openedCategory, action.categoryId];
      } else {
        ocNew = ocNew.filter(c => c !== action.categoryId);
      }
      return {
        ...state,
        openedCategory: ocNew
      };
    case CATEGORY_ACTIVE:
      return {
        ...state,
        active: parseInt(action.categoryId),
        news: false
      };
    case CATEGORY_OPEN:
      return {
        ...state,
        openedCategory: [parseInt(action.categoryId)],
        news: false
      };
    case NEWS:
      return {
        ...state,
        news: true
      };
    case LOADING_CATEGORY:
      return { ...state, loadingCategories: action.status };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/category.js